import { useMutation, useQueryClient } from "@tanstack/react-query";
import { generateReview } from "../services/review.service";
import { GenerateReviewRequest, StoredResponseResult } from "../types/review.types";

export const useGenerateReview = () => {
  const queryClient = useQueryClient();
  return useMutation<
    StoredResponseResult,
    Error,
    { request: GenerateReviewRequest; signal: AbortSignal }
  >({
    mutationFn: ({ request, signal }) => {
      return generateReview(request, signal);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["reviews"] });
    },
    onError: (error, variables) => {
      if (error.name === "CanceledError") {
        console.log("Review generation canceled for:", variables.request.query_term);
      } else {
        console.error(
          "Hook: Error generating review for:",
          variables.request.query_term,
          "Error:",
          error
        );
      }
    },
  });
};
